import Vuex from 'vuex';
import { mountExpressCheckout } from '../global-declare-components/helpers/stripeExpressCheckout'
import { Plugin } from 'vue-fragment'
import installFragmentSiblingFix from '../global-declare-components/plugins/fragment-sibling-fix'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Teleport from 'vue2-teleport';
import './plugins/vee-validate'
import './plugins/fa-icons-plugin'

window.Vuex = Vuex;

// The course checkout is inline JS in a Blade template rather than an SFC, so
// the shared Apple Pay / Google Pay helper is handed to it through window.
window.mountStripeExpressCheckout = mountExpressCheckout;

Vue.use(Plugin)
// Undo vue-fragment's over-broad sibling freeze (breaks vuedraggable / Vue patch).
installFragmentSiblingFix()

window.VueReCaptcha = VueReCaptcha;

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent, true)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent, true)
  },
});

Vue.component('course-teleport', Teleport)
Vue.component('course-modal', require('./ui/modals/course-modal').default)
Vue.component('course-input', require('./ui/forms/course-input').default)
Vue.component('course-textarea', require('./ui/forms/course-textarea').default)
Vue.component('course-select', require('./ui/forms/course-select').default)
Vue.component('course-button', require('./ui/forms/course-button').default)
Vue.component('course-checkbox-group', require('./ui/forms/course-checkbox-group').default)
Vue.component('course-radio-group', require('./ui/forms/course-radio-group').default)
Vue.component('course-loader', require('./ui/components/Loader').default)
Vue.component('registration-modal', require('../event-landing-page/ui/registration-modal/index.vue').default)
// registration-modal's subtree relies on these globally-registered components
// (same as event-landing-page/index.js); without them Vue leaves <event-checkbox>
// and <event-radio> unresolved in this bundle.
Vue.component('event-checkbox', require('../event-landing-page/ui/forms/event-checkbox').default)
Vue.component('event-radio', require('../event-landing-page/ui/forms/event-radio').default)
Vue.component('event-spinner', require('../event-landing-page/ui/shared/event-spinner').default)
// resources/js/apps/event-landing-page/ui/registration-modal/index.vue